import { render, staticRenderFns } from "./ExpandableNav.vue?vue&type=template&id=88e4eae4&"
import script from "./ExpandableNav.vue?vue&type=script&lang=js&"
export * from "./ExpandableNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports